/**
 * WordPress dependencies
 */
import { __ } from "@wordpress/i18n";

import { SelectControl } from "@wordpress/components";

export default function ModalHeader(props) {
  const { iconType, handleIconTypeChange } = props;

  return (
    <div className="icon-inserter__content-header">
      <SelectControl
        label={__("Style")}
        value={iconType}
        options={[
          { label: __("Regular"), value: "regular" },
          { label: __("Fill"), value: "fill" },
          { label: __("Duotone"), value: "duotone" },
        ]}
        onChange={handleIconTypeChange}
        __next40pxDefaultSize
        __nextHasNoMarginBottom
      />
    </div>
  );
}
